import React from 'react';
import { View, Text } from 'react-native';
import Colors from "../../constants/Colors";
import {stringIsEmpty} from "../../helpers/stringCheker";

const ProgressBar = ({ barSize, maxAmount, currentAmount, statTitle }) => {

    const currentBarAmount = (barSize * currentAmount) / maxAmount;

    return(
        <View style={{ marginBottom: 12 }}>
            {
                stringIsEmpty(statTitle) === false &&
                    <Text style={{ fontSize: 18, fontWeight: 'bold', marginBottom: 12, color: 'white' }}>
                        { statTitle }
                    </Text>
            }

            <View style={{ flexDirection: 'row', }}>
                <View style={{ borderRadius: 25, width: barSize, height: 25, backgroundColor: Colors.progressBarBackground }}>
                    <View style={{ borderRadius: 25, width: currentBarAmount, height: 25, backgroundColor: Colors.progressBarForeground }} />
                </View>

            </View>
        </View>
    )
}

export { ProgressBar };
